<template src="./dashboard.html"></template>

<script>
import Dashboard from 'Layouts/dashboard/Dashboard.vue';

export default {
  components: {
    Dashboard,
  },
};
</script>
